import { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import fetchMeetingContext from '@/app/queries/MeetingContextQuery/fetchMeetingContext';
import { copyFor, MeetingCopy } from '@/app/queries/MeetingContextQuery/meetingCopy';

export const meetingContextQuery = (meetingHash: string) => ({
  queryKey: ['meeting-context', meetingHash],
  queryFn: () => fetchMeetingContext(meetingHash),
  staleTime: Infinity,
  gcTime: Infinity,
  retry: 3,
});

export interface SettledMeetingCopy extends MeetingCopy {
  isSettled: boolean;
}

const useMeetingCopy = (): SettledMeetingCopy => {
  const { hash } = useParams<{ hash: string }>();
  const { data, isPending, failureCount } = useQuery(meetingContextQuery(hash!));
  // The first failure settles on the LVE fallback; the retries behind it must
  // not hold the lobby's title.
  const isSettled = !isPending || failureCount > 0;

  return useMemo(() => ({ ...copyFor(data?.context ?? null), isSettled }), [data, isSettled]);
};

export default useMeetingCopy;
